var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_1294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 9.05933V7.16667C17 6.24619 16.2538 5.5 15.3333 5.5H9.975C9.69915 5.5 9.44118 5.3635 9.28602 5.13543L8.08115 3.3646C7.92598 3.13651 7.668 3 7.39213 3H3.66667C2.74619 3 2 3.74619 2 4.66667V15.0141C2 15.7427 2.59064 16.3333 3.31923 16.3333V16.3333C3.99144 16.3333 4.55616 15.8279 4.63039 15.1598L5.1686 10.316C5.26238 9.47189 5.97582 8.83333 6.82507 8.83333H16.1665C16.6405 8.83333 17.0922 9.03522 17.4083 9.38846C17.7245 9.74171 17.8753 10.2129 17.8229 10.6841L17.36 14.8507C17.2662 15.6948 16.5528 16.3333 15.7035 16.3333H3.31923",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_1294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;